<template>
    <div class="tw-flex tw-space-x-5"
        :class="`${(isSentByUser ? 'tw-flex-row-reverse tw-space-x-reverse':'tw-flex-row tw-justify-start')}`"
    >
        <a href="#" class="tw-flex-shrink-0">
            <img :src="data.user.avatar" alt="" class="tw-w-10 tw-h-10 tw-rounded-full">
        </a>
        <div class="tw-max-w-2/3 tw-flex tw-flex-col tw-space-y-1" :class="`${isSentByUser ? 'tw-items-end' : 'tw-items-start'}`">
            <div class="tw-rounded tw-p-3" :class="`${isSentByUser ? 'tw-bg-green-50' : 'tw-bg-blue-50'}`">
                <!-- image file preview -->
                <div v-if="data.attachment !== null && imageExtensionsWithPreview.includes(data.attachment.ext)" style="position:relative">
                    <a  :download="data.attachment.url.replace(/^.*[\\\/]/, '')" :href="data.attachment.url"
                     class="tw-flex tw-items-center tw-space-x-2 hover:tw-text-blue-600 " style="position:absolute;top:0">
                        <i class="bx bxs-download downloadFileIcon"></i>
                        <div class="tw-max-w-64 tw-truncate"></div>
                    </a>
                    <img  :src="data.attachment.url" alt="" style="max-width:200px">
                    
                   
                </div>
                
                 <!-- video file preview -->
                <div v-else-if="data.attachment !== null && videoExtensionsWithPreview.includes(data.attachment.ext)" style="position:relative">
                    <video width="320" height="240" controls>
                        <source :src="data.attachment.url">
                        Your browser does not support the video tag.
                    </video> 
                    <a  :download="data.attachment.url.replace(/^.*[\\\/]/, '')" :href="data.attachment.url"
                     class="tw-flex tw-items-center tw-space-x-2 hover:tw-text-blue-600 " style="position:absolute;top:0">
                        <i class="bx bxs-download downloadFileIcon"></i>
                        <div class="tw-max-w-64 tw-truncate"></div>
                    </a>
                   
                </div>


                       <!-- audio file preview -->
                <div v-else-if="data.attachment !== null && audioExtensionsWithPreview.includes(data.attachment.ext)" style="position:relative">
                    
                    <div class="row" style="margin:0">
                        <div class="col-2">
                            <a  :download="data.attachment.url.replace(/^.*[\\\/]/, '')" :href="data.attachment.url"
                            class="tw-flex tw-items-center tw-space-x-2 hover:tw-text-blue-600 " style="position:absolute;top:0px">
                                <i class="bx bxs-download downloadFileIcon"></i>
                                <div class="tw-max-w-64 tw-truncate"></div>
                            </a> 

                        </div>
                        <div class="col-10">
                            <audio controls>
                            <source :src="data.attachment.url">
                            Your browser does not support the audio tag.
                            </audio>
                        </div>
                    </div>
              
                    
                   
                </div>

      
                

                <a v-else-if="data.attachment !== null" :download="data.attachment.url.replace(/^.*[\\\/]/, '')" :href="data.attachment.url" class="tw-flex tw-items-center tw-space-x-2 hover:tw-text-blue-600">
                    <i class="bx bxs-download tw-text-xl"></i>
                    <div class="tw-max-w-64 tw-truncate">{{data.attachment.url.replace(/^.*[\\\/]/, '')}}</div>
                </a>

                <template v-else-if="store.messageIsTranslating(data)">translating..</template>
                <template v-else-if="store.messageIsTranslated(data)">{{store.findTranslation(data).translation}}</template>
                <template v-else>{{data.text}}</template>
            </div>
            <div class="tw-flex tw-space-x-2 tw-text-xs">
                <div class=" tw-text-gray-500">{{data.created_at}}</div>
                <div v-if="!isSentByUser" v-on:click="store.toggleTranslation(data)"
                    tabindex="0" class="tw-cursor-pointer tw-text-blue-600"
                >{{store.translationAvailable(data) ? $text.show_original : $text.translate}}</div>
            </div>
        </div>
    </div>
</template>
<script>
    import store from './messenger-store'

    export default {
        props: {
            data: {},
            user: {},
        },
        data: function () {
            return {
                imageExtensionsWithPreview :['png','jpg','jpeg','gif','tiff'],
                videoExtensionsWithPreview :['webm','mkv','flv','ogg','ogv','avi','mov','qt','wmv','mp4','m4p','m4v','mpg','mp2','mpeg','mpe','mpv','m4v','flv'],
                audioExtensionsWithPreview :['mp3','wav'],

            };
        },

    

        created() {
            this.store = store
            this.states = store.states
        },
        computed: {
            isSentByUser() {
                return this.user.id === this.data.user.id
            }
        }
    }
</script>


<style scoped>
.downloadFileIcon{

    font-size: 20px;
    border: 1px solid gray;
    border-radius: 40px;
}
</style>